import { cqrs } from '@faro/http-clients';
import { SystemDefinedObject, toRequiredSystemDefinedObject } from '@faro/study-designer-model';

/**
 * Client responsible for managing study phases
 */
export const studyPhaseClient = cqrs<SystemDefinedObject>(
    '/api/study-designer/enumerated-values/study-phases',
    toRequiredSystemDefinedObject
).listableEntityClient();
